const {JWT} = require('google-auth-library');


const MESSAGING_SCOPE = 'https://www.googleapis.com/auth/firebase.messaging';
const SCOPES = [MESSAGING_SCOPE];

// Import ENV config
import config from '../../config';

const PROJECT_ID = config.firebase.projectId;
const HOST = 'https://fcm.googleapis.com';
const PATH = '/v1/projects/' + PROJECT_ID + '/messages:send';

const url = HOST+PATH;

export const getAccessToken = () => {
    return new Promise(function(resolve, reject) {
        const jwtClient = new JWT({
            email : config.firebase.pushNotificationEmail,
            key: config.firebase.pushNotificationKey,
            scopes : SCOPES,
        });
        jwtClient.authorize(function(err, tokens) {
            if (err) {
                reject(err);
                return;
            }
            resolve(tokens.access_token);
        });
   });
};

export const sendNotification = async ( fcmMessage ) => {
    let access_token = await getAccessToken();
    const response = await fetch(url, {
        method : 'POST',
        headers:{
            'Content-Type': 'application/json',
            'Authorization': 'Bearer' + ' ' + access_token
        },
        body: JSON.stringify(fcmMessage)
    });
    console.log(response);
}